export function StoreMarketingTagScripts({ gtagId }) {
  // useEffect(() => {
  //   if (!gtagId) return;

  //   const handleLoad = () => {
  //     // 1. Load the gtag.js script
  //     const gtagScript = document.createElement('script');
  //     gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
  //     gtagScript.async = true;
  //     document.head.appendChild(gtagScript);

  //     // 2. Inject GTM bootstrap script
  //     const gtmScript = document.createElement('script');
  //     gtmScript.innerHTML = `
  //       (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  //       new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  //       j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  //       'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  //       })(window,document,'script','dataLayer','${gtagId}');
  //     `;
  //     document.head.appendChild(gtmScript);

  //     // 3. Add gtag config script
  //     const configScript = document.createElement('script');
  //     configScript.innerHTML = `
  //       window.dataLayer = window.dataLayer || [];
  //       function gtag(){dataLayer.push(arguments);}
  //       gtag('js', new Date());
  //       gtag('config', '${gtagId}');
  //     `;
  //     document.head.appendChild(configScript);
  //   };

  //   // Run on DOMContentLoaded
  //   if (document.readyState === 'loading') {
  //     document.addEventListener('DOMContentLoaded', handleLoad);
  //   } else {
  //     handleLoad();
  //   }

  //   return () => {
  //     document.removeEventListener('DOMContentLoaded', handleLoad);
  //   };
  // }, [gtagId]);

  return (
    <>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${gtagId}`} />
      <script
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtagId}');
          `,
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${gtagId}');`,
        }}
      />
    </>
  );
}
